import { ensureRealVehicle } from './vehicleMaterializer';

export const VEHICLE_WARNING_MESSAGES = {
    NO_VEHICLE: 'No pudimos registrar tu vehículo porque no hay ningún vehículo seleccionado. Actualiza tus datos en el perfil.',
    NO_PLATE: 'No pudimos registrar tu vehículo porque no tiene placa. Actualiza tus datos en el perfil.',
    NO_DRIVER: 'No pudimos registrar tu vehículo porque no está asociado a tu perfil. Actualiza tus datos.',
    INSERT_FAILED: 'No pudimos registrar tu vehículo. Actualiza tus datos en el perfil.',
    ASSIGN_FAILED: 'No pudimos vincular tu vehículo al servicio. Actualiza tus datos en el perfil.'
};

export const DEFAULT_VEHICLE_WARNING = VEHICLE_WARNING_MESSAGES.INSERT_FAILED;

/**
 * Resuelve el vehículo real (con id) para asignarlo al servicio.
 * Los vehículos de respaldo llegan sin id: en ese caso se materializan
 * en public.vehicles antes de asignarlos.
 */
export const resolveVehicleForService = async (vehicle) => {
    if (!vehicle) {
        return {
            ok: false,
            vehicleId: null,
            warning: VEHICLE_WARNING_MESSAGES.NO_VEHICLE,
            reason: 'NO_VEHICLE',
            created: false,
            reused: false
        };
    }

    if (vehicle.id) {
        return { ok: true, vehicleId: vehicle.id, warning: null, reason: null, created: false, reused: false };
    }

    const result = await ensureRealVehicle(vehicle);

    if (result?.ok && result.vehicle?.id) {
        return {
            ok: true,
            vehicleId: result.vehicle.id,
            warning: null,
            reason: null,
            created: Boolean(result.created),
            reused: Boolean(result.reused)
        };
    }

    const reason = result?.reason || 'INSERT_FAILED';
    return {
        ok: false,
        vehicleId: null,
        warning: VEHICLE_WARNING_MESSAGES[reason] || DEFAULT_VEHICLE_WARNING,
        reason,
        created: false,
        reused: false
    };
};
